import React from 'react';
import classnames from 'classnames';
import { 
  PasterCategory,
  PasterOption,
  Paster2ndCategory,
  Paster,
  Annex1stCategory,
  Annex2ndCategory,
  Annex,
  PasterAnnexOption
} from '@/sunzi';
import Icon from '../icon';
import { i18n, thumbnail7n } from '@/utils';
import styles from './style.less';

export interface EditPasterProps {
  active: PasterOption;
  dataSource: PasterCategory[];
  onApply: (paster: PasterOption) => void
}

export interface EditPasterState {
  scs: Paster2ndCategory[];
  ps: Paster[];
  facs: Annex1stCategory[];
  current: PasterOption;
}

class EditPaster extends React.Component<EditPasterProps, EditPasterState> {
  constructor(props: EditPasterProps) {
    super(props);
    const { scs, ps, facs } = this._initialize(props);
    this.state = {
      scs,
      ps,
      facs,
      current: props.active
    };
  }

  /**
   * 初始化构建
   */
  _initialize = (props: EditPasterProps): {
    scs: Paster2ndCategory[];
    ps: Paster[];
    facs: Annex1stCategory[];
  } => {
    const { active, dataSource } = props;
    // 当前的主体一级分类
    const _fc = dataSource.find(item => item.id === active.fcid);
    // 当前主体一级分类下的二级分类集合
    const scs = (_fc && _fc.children) || [];
    // 当前的主体二级分类
    const _sc = scs.find(item => item.id === active.scid);
    // 当前主体二级分类的主体集合
    const ps = (_sc && _sc.children) || [];
    // 当前的主体
    const _p = ps.find(item => item.id === active.id);
    // 当前的主体下的配件一级分类集合
    const facs = (_p && _p.children) || [];
    return {
      scs,
      ps,
      facs
    };
  }

  /** 数据切换 */
  _onCurrentChange = (fcid?: number, scid?: number, pid?: number, sacid?: number, aid?: number) => {
    const { dataSource } = this.props;
    const { current } = this.state;
    // 当前的主体一级分类
    let _fc: PasterCategory | undefined = dataSource[0];
    current.fcid = _fc.id;
    if (fcid) {
      _fc = dataSource.find(item => item.id === fcid);
      current.fcid = fcid;
    }
    // 当前主体一级分类下的二级分类集合
    const scs = (_fc && _fc.children) || [];
    // 当前的主体二级分类
    let _sc: Paster2ndCategory | undefined = scs[0];
    current.scid = _sc.id;
    if (scid) {
      _sc = scs.find(item => item.id === scid);
      current.scid = scid;
    }
    // 当前主体二级分类的主体集合
    let ps = (_sc && _sc.children) || [];
    // 当前的主体
    let _p: Paster | undefined = ps[0];
    if (pid) _p = ps.find(item => item.id === pid);
    if (_p) {
      current.id = _p.id;
      current.image = _p.image;
      current.cropImage = _p.cropImage;
    }
    // 当前的主体下的配件一级分类集合
    const facs = (_p && _p.children) || [];
    const _annexs: PasterAnnexOption[] = [];
    
    facs.forEach(fac => {
      // 获取当前一级配件分类的所有二级配件分类
      const _sacs = fac.children;
      // 当前的二级配件分类
      let _sac: Annex2ndCategory | undefined = _sacs[0];
      if (sacid) _sac = _sacs.find(sac => sac.id === sacid);
      // 获取当前二级配件分类下的所有配件
      const _as = (_sac && _sac.children) || [];
      // 当前的配件
      let _a: Annex | undefined = _as[0];
      if (aid) _a = _as.find(item => item.id === aid);
      if (_sac && _a) {
        _annexs.push({
          id: _a.id,
          facid: fac.id,
          sacid: _sac.id,
          name: _a.name,
          image: _a.image,
          thumbnail: _a.thumbnail,
        });
      } else {
        // 当前一级分类存在于原来的current.annexs里
        const _cas = current.annexs.find(item => fac.id === item.facid);
        if (_cas) _annexs.push(_cas);
      }
    });
    current.annexs = _annexs;
    this.setState({
      scs,
      ps,
      facs,
      current
    });
  }

  /** 切换一级分类 */
  handleCategoryChange = (fc: PasterCategory) => () => {
    const { current } = this.state;
    if (fc.id === current.fcid) return;
    this._onCurrentChange(fc.id);
  }

  /** 
   * 切换二级分类
   * select onChange 不用判断是否相同
   */
  handleCategory2ndChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { current } = this.state;
    this._onCurrentChange(current.fcid, parseInt(e.target.value));
  }

  /** 切换主体 */
  handlePasterChange = (paster: Paster) => () => {
    const { current } = this.state;
    if (paster.id === current.id) return;
    this._onCurrentChange(current.fcid, current.scid, paster.id);
  }

  /** 切换配件二级分类 */
  handleAnnexCategory2ndChange = (sacid: string) => {
    const { current } = this.state;
    this._onCurrentChange(current.fcid, current.scid, current.id, parseInt(sacid));
  }

  /** 切换配件 */
  handleAnnexChange = (sac?: Annex2ndCategory, annex?: Annex) => () => {
    const { current } = this.state;
    this._onCurrentChange(current.fcid, current.scid, current.id, sac && sac.id, annex && annex.id);
  }

  // 点击确认
  handleApply = () => {
    const { current } = this.state;
    this.props.onApply(current);
  }

  render() {
    const { dataSource } = this.props;
    const { scs, ps, facs, current } = this.state;
    // 当前的一级分类
    const _fc = dataSource.find(item => item.id === current.fcid);
    // 当前的二级分类
    const _sc = scs.find(item => item.id === current.scid);
    // 根据主体个数更改select margin
    const scsSelectStyle = classnames(
      styles.blockSelectWrap, {
        [styles.blockSelectWithChildren]: true, // ps.length > 1
      }
    );
    // 根据主体个数更改配件排列方式
    const pasterWrapStyle = classnames(
      styles.blockContentWrap, {
        [styles.blockContentColumnWrap]: false // ps.length > 12
      }
    );
    return (
      <div className={styles.edit}>
        <div className={styles.editContent}>
          <div className={styles.title}>{i18n.format('components.edit.title')}</div>
          {/* 一级分类 */}
          {dataSource.length > 1 && (
            <div className={styles.block}>
              <div className={styles.blockTitle}>{i18n.format('components.edit.type')}</div>
              <div className={styles.blockContent}>
                {dataSource.map(item => {
                  const isActive = current.fcid === item.id;
                  const categoryStyle = classnames(
                    styles.category, {
                      [styles.blockContentItemActive]: isActive
                    }
                  );
                  return (
                    <div key={item.id} className={styles.blockContentItem} onClick={this.handleCategoryChange(item)}>
                      <div className={categoryStyle}>
                        <img className={styles.categoryImage} src={isActive ? item.activeImage : item.image}></img>
                        <div className={styles.categoryName}>{item.name}</div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
          {/* 二级分类 */}
          {(scs.length > 1 || ps.length > 1) && (
            <div className={styles.block}>
              <div className={styles.blockTitle}>{_fc && _fc.label}</div>
              {/* 当前激活的二级分类 */}
              {scs.length > 1 && (
                <div className={scsSelectStyle}>
                  <div className={styles.blockSelect}>
                    <div>
                      {_sc && _sc.image && 
                        <img className={styles.blockSelectImage} src={_sc.image} />
                      }
                      <div className={styles.blockSelectValue}>{_sc && _sc.name}</div>
                    </div>
                    <Icon type="down" color="#a1a1a1"></Icon>
                  </div>
                  {/* 二级分类的select */}
                  <select value={_sc && _sc.id} onChange={this.handleCategory2ndChange}>
                    {scs.map(item => 
                      <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                  </select>
                </div>
              )}
              {/* 当前主体 */}
              <div className={pasterWrapStyle}>
                {ps.map(item => {
                  const pasterStyle = classnames(
                    styles.paster, {
                      [styles.blockContentItemActive]: current.id === item.id
                    }
                  );
                  return (
                    <div key={item.id} className={styles.blockContentItem} onClick={this.handlePasterChange(item)}>
                      <div className={pasterStyle}>
                        <img src={thumbnail7n(item.image, 120)}></img>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {/* 一级配件分类 */}
          {facs.map(fac => {
            // 二级配件分类集合
            const _sacs = fac.children;
            // 当前的配件
            const _aa = current.annexs.find(item => item.facid === fac.id);
            // 当前的二级配件分类
            const _sac = _sacs.find(item => item.id === (_aa && _aa.sacid));
            // 当前二级配件分类的下的所有配件
            const _as = (_sac && _sac.children) || [];
            // 根据配件个数更改select margin
            const sacsSelectStyle = classnames(
              styles.blockSelectWrap, {
                [styles.blockSelectWithChildren]: _as.length > 1
              }
            );
            // 根据配件个数更改配件排列方式
            const annexWrapStyle = classnames(
              styles.blockContentWrap, {
                [styles.blockContentColumnWrap]: false // _as.length > 12
              }
            );
            if (_sacs.length > 1 || _as.length > 1)
              return (
                <div key={fac.id} className={styles.block}>
                  <div className={styles.blockTitle}>{fac.name}</div>
                  {_sacs.length > 1 && (
                    <div className={sacsSelectStyle}>
                      {_sac && (
                        <div className={styles.blockSelect}>
                          <div className={styles.blockSelectValue}>{_sac.name}</div>
                          <Icon type="down" color="#a1a1a1"></Icon>
                        </div>
                      )}
                      <select value={_sac && _sac.id} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => this.handleAnnexCategory2ndChange(e.target.value)}>
                        {_sacs.map(item => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                  )}
                  {/* 配件 */}
                  {_as.length > 1 && (
                    <div className={annexWrapStyle}>
                      {_as.map(item => {
                        const annexStyle = classnames(
                          styles.annex, {
                            [styles.blockContentItemActive]: _aa && _aa.id === item.id
                          }
                        );
                        return (
                          <div key={item.id} className={styles.blockContentItem} onClick={this.handleAnnexChange(_sac, item)}>
                            <div className={annexStyle}>
                              <img src={thumbnail7n(item.thumbnail, 80)}></img>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            return null;
          })}
        </div>
        <div className={styles.editFooter}>
          <div className={styles.applyButton} onClick={this.handleApply}>{i18n.format('components.edit.apply')}</div>
        </div>
      </div>
    )
  }
};

export default EditPaster;